export const validLabsColumns = [
    {
        Header: 'Name',
        accessor: 'name',
        enableFilter: true,
    },
    {
        Header: 'Contact Person',
        accessor: 'contactPerson',
        enableFilter: true,
    },
    {
        Header: 'Phone',
        accessor: 'phone',
        enableFilter: true,
    },
    {
        Header: 'Email',
        accessor: 'email',
        enableFilter: true,
    },
    // {
    //     Header: 'Specialties',
    //     accessor: 'specialties',
    //     enableFilter: true,
    // },
    // {
    //     Header: 'Turnaround Days',
    //     accessor: 'turnaroundDays',
    //     type: 'number'
    // },
]